<template>
    <section class="col-xs-12 col-sm-5">
        <div class="calendar__info">
            <div class="calendar__info__item">
                <h4 class="calendar__info__title">{{ $t('FIRST_PERIOD_DAY') }}</h4>
                <div class="calendar__info__date__wrapper">
                    <div class="calendar__info__date">
                        <span>{{ firstPeriodDay | moment('dd') }}</span>
                        <span class="date__day-number">{{ firstPeriodDay | moment('DD') }}</span>
                    </div>
                    <div class="calendar__info__month">
                        <span>{{ firstPeriodDay | moment('MMM') }} {{ firstPeriodDay | moment('YYYY') }}</span>
                    </div>
                </div>

                <div class="calendar__info__tooltip box-shadow">
                    {{ $t('FIRST_PERIOD_DAY_INFO') }}
                    <!--<strong>{{ $t('CLICK_CALENDAR')}}</strong>-->
                </div>
            </div>
            <div class="calendar__info__item">
                <div class="next-examination__wrapper">
                    <h4 class="calendar__info__title">{{ $t('NEXT_BRASTER_EXAMINATION') }}:</h4>

                    <div class="next-examination__legend"></div>

                    <div class="next-examination__date" v-if="firstAllowedDay">
                        {{ dateFormat(firstAllowedDay) }}-{{ dateFormat(lastAllowedDay) }}
                        <a style="cursor: pointer" class="trigger" @click="showVideo()"
                            >{{ $t('HOW_TO_MAKE_EXAMINATION') }}
                            <img class="link-img" src="/src/assets/images/arrow-red.png" />
                        </a>
                    </div>

                    <div class="next-examination__date" v-else>
                        <span class="trigger">{{ $t('SELECT_DATE_FROM_CALENDAR') }}</span>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
var moment = require('moment');

export default {
    props: {
        firstPeriodDay: String,
        firstAllowedDay: String,
        lastAllowedDay: String,
    },
    data() {
        return {};
    },
    methods: {
        showVideo() {
            this.$emit('showVideo');
        },
    },
    components: {},
};
</script>

<style scoped>
a {
    cursor: pointer;
}

.link-img {
    padding-bottom: 3px;
    width: 12px;
}
</style>



// WEBPACK FOOTER //
// braster-allowed.vue?bcf1924e